// extracted by mini-css-extract-plugin
export var areasContainer = "AreasOfExpertise-module--areas-container--d74a0";
export var paddingContainerAreas = "AreasOfExpertise-module--padding-container-areas--1ed93";